import { render } from "./CampaignDetailCards.vue?vue&type=template&id=29903e5b&ts=true"
import script from "./CampaignDetailCards.vue?vue&type=script&lang=ts"
export * from "./CampaignDetailCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__